/* RESPONSIBLE TEAM: team-self-serve */
import { startSurvey } from 'embercom/lib/intercom-widget-helper';
import Metrics from 'embercom/models/metrics';
import ENV from 'embercom/config/environment';
import type RouterService from '@ember/routing/router-service';

const CHURN_SURVEY_METRIC_NAME = 'intercom_churn_survey_missing_after_trigger';
const USER_MISSING_CHURN_SURVEY_SKIPPED_METRIC_NAME = 'intercom_user_missing_churn_survey_skipped';

export default function launchSurveyAndTrack(surveyId: number, app: any, router: RouterService) {
  if (app.shouldHideCancelationSurvey) {
    redirectToExitSurvey(router);
    return;
  }

  // Confirm that Intercom-Js is loaded and we have a user, otherwise redirect to billing settings
  let whoami = window.Intercom('whoami');
  if (whoami === undefined) {
    Metrics.sendInteractionMetrics([
      {
        name: USER_MISSING_CHURN_SURVEY_SKIPPED_METRIC_NAME,
      },
    ]);
    redirectToExitSurvey(router);
    return;
  }
  startSurvey(surveyId);
  let timeout = setTimeout(() => {
    let survey = window.document.querySelector('[name="intercom-modal-frame"]');
    if (!survey && ENV.environment !== 'test') {
      Metrics.sendInteractionMetrics([
        {
          name: CHURN_SURVEY_METRIC_NAME,
        },
      ]);
    }
    clearTimeout(timeout);
  }, ENV.APP.launchSurveyTimeoutMs);
}

function redirectToExitSurvey(router: RouterService) {
  router.transitionTo('apps.app.settings.subscription.billing.settings', {
    queryParams: {
      redirect_source: 'exit_survey',
    },
  });
}
